<template>
    <div class="home-deposit-methods">
        <div class="methods-title">
            <span class="gradient-purple">{{ $t('hodep.1') }}</span>
        </div>
        <div class="methods-content">

            
            <button v-on:click="homeCashierButton" class="button-method">
                Payfix
                <img src="@/assets/img/cashier/payfix.png" />
            </button>
            <button v-on:click="homeCashierButton" class="button-method">
                Papara
                <img src="@/assets/img/cashier/papara.png" />
            </button>
            <button v-on:click="homeCashierButton" class="button-method">
                TRX
                <img src="@/assets/img/cashier/trx.png" />
            </button>
            <button v-on:click="homeCashierButton" class="button-method">
                BTC
                <img src="@/assets/img/cashier/btc.png" />
            </button>
            <button v-on:click="homeCashierButton" class="button-method">
                ETH
                <img src="@/assets/img/cashier/eth.png" />
            </button>
            <button v-on:click="homeCashierButton" class="button-method">
                LTC
                <img src="@/assets/img/cashier/ltc.png" />
            </button>
            <button v-on:click="homeCashierButton" class="button-method">
                {{ $t('hodep.2') }}
                <img src="@/assets/img/cashier/credit.png" />
            </button>
            <button v-on:click="homeCashierButton" class="button-method">
                {{ $t('hodep.3') }}
                <img src="@/assets/img/cashier/gift.png" />
            </button>

        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'HomeDepositMethods',
        methods: {
            ...mapActions(['notificationShow', 'modalsSetShow']),
            homeCashierButton() {
                if(this.authUser.user === null) {
                    this.notificationShow({ type: 'error', message: 'Please sign in to perform this action.' });
                    return;
                }

                this.modalsSetShow('Cashier');
            }
        },
        computed: {
            ...mapGetters(['authUser'])
        }

    }
</script>

<style scoped>
    .home-deposit-methods {
        width: 100%;
        position: relative;
        margin-top: 85px;
    }

    .home-deposit-methods::before {
        content: '';
        width: 100%;
        height: 1px;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(90deg, rgba(2, 25, 44, 0) 0%, #ffeb00 calc(50% - 110px), rgba(2, 25, 44, 0) calc(50% - 108px), rgba(2, 25, 44, 0) calc(50% + 108px), #ffeb00 calc(50% + 110px), rgba(2, 25, 44, 0) 100%);
        z-index: -1;
    }

    .home-deposit-methods::after {
        content: '';
        width: 100%;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: linear-gradient(90deg, rgba(3, 28, 49, 0) 0%, #ffeb00 50%, rgba(3, 28, 49, 0) 100%);
        z-index: 0;
    }

    .home-deposit-methods .methods-title {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        white-space: nowrap;
        font-size: 18px;
        font-weight: 800;
    }

    .home-deposit-methods .methods-content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 30px 0;
        background: radial-gradient(50% 40% at 50% 90%, rgb(216 255 0 / 45%), rgba(26, 4, 54, 0) 100%);
    }

    .home-deposit-methods button.button-method {
        width: 12.5%;
        height: 105px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        font-size: 12px;
        font-weight: 800;
        color: #ffffff;
    }

    .home-deposit-methods button.button-method.method-placeholder {
        color: #ffeb00;
        text-shadow: -1px 1px 0 #223a4e, 1px 1px 0 #223a4e, 1px -1px 0 #223a4e, -1px -1px 0 #223a4e;
    }

    .home-deposit-methods button.button-method::before {
        content: '';
        width: 2px;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(0deg, rgba(3, 28, 49, 0) 0%, #ffeb00 50%, rgba(3, 28, 49, 0) 100%);
    }

    .home-deposit-methods button.button-method:last-of-type::before {
        background: none;
    }

    .home-deposit-methods button.button-method img {
        height: 61px;
    }

    @media only screen and (max-width: 1600px) {

        .home-deposit-methods {
            width: 100%;
        }

    }

    @media only screen and (max-width: 950px) {

        .home-deposit-methods button.button-method {
            height: 80px;
            font-size: 11px;
        }

        .home-deposit-methods button.button-method img {
            height: 40px;
        }

    }

    @media only screen and (max-width: 750px) {

        .home-deposit-methods button.button-method {
            width: 25%;
        }

        .home-deposit-methods button.button-method:nth-child(1),
        .home-deposit-methods button.button-method:nth-child(2),
        .home-deposit-methods button.button-method:nth-child(3),
        .home-deposit-methods button.button-method:nth-child(4) {
            margin-bottom: 20px;
        }

        .home-deposit-methods button.button-method:nth-child(4)::before {
            display: none;
        }

    }
</style>
